import AsyncStorage from "@react-native-async-storage/async-storage";
import { isAppLanguage, isSystemLanguage, type AppLanguage } from "./i18n";

const LANGUAGE_STORAGE_KEY = "app.language";

export async function getStoredLanguage(): Promise<AppLanguage | null> {
    const value = await AsyncStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (!value || (!isAppLanguage(value) && !isSystemLanguage(value))) {
        return null;
    }
    return value;
}

export async function setStoredLanguage(language: AppLanguage): Promise<void> {
    await AsyncStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}
